import {Component, Input, OnInit} from '@angular/core';
import { MaterialModule } from "src/app/app.materials";
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-popover',
  templateUrl: './popover.component.html',
  styleUrls: ['./popover.component.scss'],
  imports: [MaterialModule, CommonModule],
  standalone: true,
})
export class PopoverComponent implements OnInit {
  @Input() company: any;
  @Input() hideFreq = false;
  @Input() currency = 'USD';

  constructor() { }

  ngOnInit(): void {
  }

}
